import { Injectable } from '@angular/core';
import { TrackingService } from '../library/tracking.service';

@Injectable({
  providedIn: 'root',
})
export class TrackingContactUsService {
  trackViewFlag: boolean;

  constructor(private trackingService: TrackingService) {
    this.trackViewFlag = true;
  }

  trackViewHome = () => {
    if (this.trackViewFlag) {
      this.trackingService.trackView();
      this.trackViewFlag = false;
    }
  };

  trackContact = (contactType: string) => {
    this.trackingService.trackLink('fiche_contact', contactType);
  };

  trackTile = (levelTile: string, nameTile: string) => {
    this.trackingService.trackLink(levelTile, nameTile);
  };
}
